// extracted by mini-css-extract-plugin
module.exports = {"loadingDivShow":"PleaseWait_loadingDivShow__nUA_d","loadingDivHide":"PleaseWait_loadingDivHide__2zftH"};